// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11":"31d6cfe0","192":"7def0a15","311":"31d6cfe0"}[chunkId] + ".chunk.css";
};